import React from 'react'

interface PurchaseActionButtonProps {
  label: string
  title: string
  onClick: () => void
}

/** Compact outline action used beside subscription fields. */
export const PurchaseActionButton: React.FC<PurchaseActionButtonProps> = ({
  label,
  title,
  onClick,
}) => (
  <button
    type='button'
    className='btn btn-sm btn-outline-primary py-0 px-2 flex-shrink-0'
    onClick={onClick}
    title={title}
  >
    <i className='fas fa-plus me-1' style={{fontSize: '0.75em'}} />
    <span style={{fontSize: '0.8em'}}>{label}</span>
  </button>
)
